/**
 * Campaign Journal & Session Plan DB Types
 */
export function dbToJournalEntry(db) {
    return {
        id: db.id,
        campaignId: db.campaign_id,
        sessionPlanId: db.session_plan_id ?? undefined,
        source: db.source,
        title: db.title ?? undefined,
        body: db.body,
        sceneNames: db.scene_names ?? [],
        createdAt: db.created_at,
        updatedAt: db.updated_at,
    };
}
//# sourceMappingURL=journal-types.js.map